import { render, staticRenderFns } from "./ClientTickets.vue?vue&type=template&id=599106b2"
import script from "./ClientTickets.vue?vue&type=script&lang=js"
export * from "./ClientTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports